import styled from "styled-components";

const BlogListStyleWrapper = styled.div`

  background: #0d102d;

  .blog_lists_wrapper {
    padding: 110px 0;
  }

  .blog_items_row {
    row-gap: 30px;
  }

  @media only screen and (max-width: 912px) {
    .blog_lists_wrapper {
      padding: 80px 0 100px;
    }
  }

  @media only screen and (max-width: 568px) {
    .blog_lists_wrapper {
      padding: 60px 0 80px;
    }
  }
`;

export default BlogListStyleWrapper;
